import { Outlet } from 'react-router-dom';

export default function PaymentLinks() {
    return (
        <Outlet />
    )
}
